<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <rect width="64" height="64" fill="none"/>
    <g>
      <g>
        <path class="filled" d="M43.589,55.556h-30.3a5.55,5.55,0,0,1-5.55-5.55V16.188a5.55,5.55,0,0,1,5.55-5.55H26.764a.907.907,0,0,1,.725,1.451l-1.512,2.016a2.431,2.431,0,0,1-1.946.973H13.291a1.11,1.11,0,0,0-1.11,1.11V50.006a1.11,1.11,0,0,0,1.11,1.11h30.3a1.11,1.11,0,0,0,1.11-1.11V33.122a1.11,1.11,0,0,1,1.11-1.11h2.22a1.11,1.11,0,0,1,1.11,1.11V50.006A5.55,5.55,0,0,1,43.589,55.556Z" fill="currentColor"/>
        <rect class="filled" x="19.95" y="31.008" width="16.98" height="4.44" rx="1.11" fill="currentColor"/>
        <rect class="filled" x="19.95" y="39.883" width="16.98" height="4.44" rx="1.11" fill="currentColor"/>
        <rect class="filled" x="19.95" y="22.133" width="6.534" height="4.44" rx="1.11" fill="currentColor"/>
      </g>
      <g>
        <path class="filled" d="M57.729,16.663a2.207,2.207,0,0,1,0,2.868c-2.3,2.689-7.813,8.219-14.248,8.219s-11.947-5.53-14.247-8.219a2.2,2.2,0,0,1,0-2.868c2.3-2.689,7.813-8.219,14.247-8.219S55.429,13.974,57.729,16.663Z" fill="currentColor"/>
        <circle class="cutout" cx="43.481" cy="18.097" r="4.636" fill="#fff"/>
      </g>
    </g>
  </g>
</svg>
